module.exports = __webpack_public_path__ + "static/media/bicycle_3_bicycle.90f7baa9.png";